module.exports = __webpack_public_path__ + "static/media/accord-healthcare.a737b59f.jpg";